/**
 * Utility functions, 
 * ALERT!!!!!!!!!!!!!!!!!!
 *   When updating this file also update the backend file
 */

/**
 * Calculate the new prices, it doesn't change anything in the database
 * @param {*} row
 * @param {*} cotization
 * @param {*} dollarValueFactors
 */
function getNewPricesForRow(row, cotization, dollarValueFactors) {
  /**
     *    Example Formula
     *
     * B1 - cotization.platinum_price
     * B2 - cotization.paladium_price
     * B3 - cotization.rhodium_price
     * B5 - cotization.days_out
     * B6 - cotization.lease_rate
     * H -  row.pondered_total_pt
     * I -  row.pondered_total_pl
     * J -  row.pondered_total_rh
     * C7 - cotization.perc_return_pt
     * C8 - cotization.perc_return_pl
     * C9 - cotization.perc_return_rh
     * K -  row.weigth_grams
    +(((((($B$1 - ($B$1 * ($B$5 / 360) * ($B$6 / 100))) / 31.1035)) * (((H4715 * $C$7) / 100) / 1000000)) * K4715) +
        ((((($B$2 - ($B$2 * ($B$5 / 360) * ($B$6 / 100))) / 31.1035)) * (((I4715 * $C$8) / 100) / 1000000)) * K4715) +
        ((((($B$3 - ($B$3 * ($B$5 / 360) * ($B$6 / 100))) / 31.1035)) * (((J4715 * $C$9) / 100) / 1000000)) * K4715))

    */
  let platinum = calculateMetalPart(
    cotization.platinum_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pt,
    cotization.perc_return_pt,
    row.weigth_grams
  );
  let paladium = calculateMetalPart(
    cotization.paladium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pd,
    cotization.perc_return_pl,
    row.weigth_grams
  );
  let rhodium = calculateMetalPart(
    cotization.rodium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_rh,
    cotization.perc_return_rh,
    row.weigth_grams
  );
  let calculatedReturnUS = platinum + paladium + rhodium;

  let dinamicFactor = 0.0;
  try {
    dinamicFactor = getFactorByValue(dollarValueFactors, calculatedReturnUS);
  } catch (err) {
    console.log({
      id: row.id,
      sample_id: row.sample_id,
      calculatedReturnUS: calculatedReturnUS,
      message: 'notFound',
      error: err.message
    });
  }
  let originalFactor = getFactorByReference(
    dollarValueFactors,
    row.original_pl_factor
  );
  let RHODIUM_FACTOR = 83;

  platinum = calculateMetalPart(
    cotization.platinum_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pt,
    originalFactor,
    row.weigth_grams
  );
  paladium = calculateMetalPart(
    cotization.paladium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pd,
    originalFactor,
    row.weigth_grams
  );
  rhodium = calculateMetalPart(
    cotization.rodium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_rh,
    RHODIUM_FACTOR,
    row.weigth_grams
  );
  let originalDllValue = platinum + paladium + rhodium;

  platinum = calculateMetalPart(
    cotization.platinum_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pt,
    dinamicFactor,
    row.weigth_grams
  );
  paladium = calculateMetalPart(
    cotization.paladium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_pd,
    dinamicFactor,
    row.weigth_grams
  );
  rhodium = calculateMetalPart(
    cotization.rodium_price,
    cotization.days_out,
    cotization.lease_rate,
    row.total_rh,
    RHODIUM_FACTOR,
    row.weigth_grams
  );
  let dinamicDllValue = platinum + paladium + rhodium;

  let newPrices = dinamicDllValue - row.process;

  const OPERATIONAL_COST_FACTOR = 0.0090;

  let newOperationalCost = newPrices * OPERATIONAL_COST_FACTOR;

  let newDollarPrice = newPrices - newOperationalCost;
  let newPesosPrice = newDollarPrice * cotization.dollar_price;

  let newDollarUtility = calculatedReturnUS - originalDllValue;
  let newPesosUtility = newDollarUtility * cotization.dollar_price;

  let newValuePerLb = 0;
  if (row.weigth_lb) {
    newValuePerLb = newPrices / row.weigth_lb;
  }

  return {
    id: row.id,
    serial_number: row.serial_number,
    newValues: {
      return_us: calculatedReturnUS,
      original_dll_value: originalDllValue,
      dinamic_dll_value: dinamicDllValue,
      prices: newPrices,
      operational_cost: newOperationalCost,
      dollar_price: newDollarPrice,
      pesos_price: newPesosPrice,
      dollar_utility: newDollarUtility,
      pesos_utility: newPesosUtility,
      value_per_lb: newValuePerLb
    },

    oldValues: {
      return_us: row.return_us,
      dll_value: row.dollar_value,
      prices: row.prices,
      operational_cost: row.operational_cost,
      dollar_price: row.dollar_price,
      pesos_price: row.pesos_price,
      dollar_utility: row.dollar_utility,
      pesos_utility: row.pesos_utility,
      value_per_lb: row.value_per_lb
    }
  };
}

function getFactorByValue(factors, value) {
  try {
    return factors.filter(e => {
      return e.min < value && value <= e.max;
    })[0].value;
  } catch (e) {
    throw e;
  }
}

function getFactorByReference(factors, reference) {
  return factors.filter(e => {
    return e.sheet_reference === reference;
  })[0].value;
}

/**
 * The order of the params is the same as in the formula
 *  ((((($B$3 - ($B$3 * ($B$5 / 360) * ($B$6 / 100))) / 31.1035)) * (((J4715 * $C$9) / 100) / 1000000)) * K4715))
 * = +(((((($B$1 - ($B$1 * ($B$5 / 360) * ($B$6 / 100))) / 31.1035)) * (((H14 * $M$4) / 100) / 1000000)) * K14)
 * @param {*} metalPrice
 * @param {*} daysOut
 * @param {*} leaseRate
 * @param {*} metalProportion
 * @param {*} metalReturn
 * @param {*} weigthGrams
 */
function calculateMetalPart(
  metalPrice,
  daysOut,
  leaseRate,
  metalProportion,
  metalReturn,
  weigthGrams
) {
  let metalRating =
    (metalPrice - metalPrice * (daysOut / 360) * (leaseRate / 100)) / 31.1035;
  let partsPerMillion = (metalProportion * metalReturn) / 100 / 1000000;
  return metalRating * partsPerMillion * weigthGrams;
}

module.exports.getNewPricesForRow = getNewPricesForRow;
